import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CssBaseline, Typography, ThemeProvider } from "@mui/material";

import { theme } from "./theme/theme";

import { WeblinkPage } from "./routes/weblink-page";
import { WebScanPage } from "./routes/web-scan-page";
import { ComingSoonPage } from "./routes/coming-soon-page";
import { ErrorPage } from "./routes/error-page";
import { orderLoader } from "./routes/order-loader";
import { customers } from "./config";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Pick the page that handles a customer's orders based on its platform.
function elementForCustomer(customer) {
  switch (customer.platform) {
    case "ios":
      return (
        <WeblinkPage
          appName={customer.appName}
          appAddress={customer.appAddress}
        />
      );
    case "android":
      return <ComingSoonPage appName={customer.appName} platform="Android" />;
    case "web":
    default:
      // Default to web based 3D scanner when platform is omitted.
      return (
        <WebScanPage
          appName={customer.appName}
          labId={customer.labId}
          fileFormats={customer.fileFormats}
        />
      );
  }
}

const routerConfig = [
  {
    path: "/",
    element: (
      <Typography align="center" m={3}>
        This website is not intended for general browsing.
      </Typography>
    ),
    errorElement: <ErrorPage />,
  },
];

customers.forEach((customer) =>
  routerConfig.push({
    path: customer.namespace + "/:order",
    element: elementForCustomer(customer),
    errorElement: <ErrorPage />,
    loader: orderLoader,
  }),
);

const router = createBrowserRouter(routerConfig);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>,
);
